(function(){'use strict';Array.from(document.querySelectorAll(".market-selector-btn")).forEach((function(e){e.addEventListener("click",(function(t){t.preventDefault();var r=e.dataset.currentCountryCode,c=e.dataset.currentLanguageCode;document.querySelector(".orbe-market-selector-wrapper #md-footer-selector__country-popup").click(),document.querySelector('#orbeCountryList [data-country="'.concat(r,'"] a')).click(),document.querySelector('#orbeLanguageList [data-value="'.concat(c,'"]')).click();}));}));})();




<!-- cart shipping variant c -->
// class ShippingCalculator {
//   constructor() {
//     this.initialize();
//     this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
//       setTimeout(() => this.initialize(), 1000);
//     });
//     document.addEventListener('cart:updated', () => {
//       setTimeout(() => this.initialize(), 1000);
//     });
//   }

//   initialize() {
//     this.select = document.getElementById('shipping-country');
//     this.shippingDisplay = document.getElementById('shipping-price');
//     this.totalDisplay = document.querySelector('.cart-drawer__footer .totals__total-value');

//     if (this.select && this.shippingDisplay && this.totalDisplay) {
//       this.select.removeEventListener('change', this.updatePrices);

//       const cartTotal = document.querySelector('[data-cart-total]');
//       let totalValue;

//       if (cartTotal) {
//         totalValue = parseFloat(cartTotal.dataset.cartTotal);
//       } else {
//         const totalText = this.totalDisplay.textContent.trim();
//         totalValue = parseFloat(totalText.replace(/[^\d,.-]/g, '').replace(',', '.'));
//       }

//       this.totalDisplay.dataset.originalTotal = isNaN(totalValue) ? '0' : totalValue.toString();

//       this.select.addEventListener('change', this.updatePrices.bind(this));

//       this.updatePrices();
//     }
//   }

//   updatePrices() {
//     if (!this.select || !this.shippingDisplay || !this.totalDisplay) return;

//     const selectedOption = this.select.options[this.select.selectedIndex];
//     const shippingPrice = parseFloat(selectedOption.value);
//     const currencySymbol = selectedOption.dataset.currency;
//     const formattedPrice = shippingPrice.toFixed(2).replace('.', ',');

//     this.shippingDisplay.textContent = `${formattedPrice} ${currencySymbol}`;


//     const originalTotal = parseFloat(this.totalDisplay.dataset.originalTotal || '0');
//     const total = originalTotal + shippingPrice;
//     const formattedTotal = total.toFixed(2).replace('.', ',');

//     this.totalDisplay.textContent = `${formattedTotal} ${currencySymbol}`;
//   }
// }

// document.addEventListener('DOMContentLoaded', () => {
//   new ShippingCalculator();
// });

<!-- cart shipping variant c end -->

(function(){'use strict';Array.from(document.querySelectorAll(".market-selector-btn")).forEach((function(e){e.addEventListener("click",(function(t){t.preventDefault();var r=e.dataset.currentCountryCode,c=e.dataset.currentLanguageCode;document.querySelector(".orbe-market-selector-wrapper #md-footer-selector__country-popup").click(),document.querySelector('#orbeCountryList [data-country="'.concat(r,'"] a')).click(),document.querySelector('#orbeLanguageList [data-value="'.concat(c,'"]')).click();}));}));})();


/* home nav */
document.addEventListener('DOMContentLoaded', function() {
  const navLinks = document.querySelectorAll('.home-nav-inner ul li a');
  const sections = [];

  navLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href.startsWith('#')) {
      const sectionId = href.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        sections.push({
          link: link,
          element: section,
          id: sectionId
        });
      }
    }
  });


  navLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const href = this.getAttribute('href');
      if (href.startsWith('#')) {
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {

          const isAlreadyActive = this.classList.contains('active');

          navLinks.forEach(navLink => navLink.classList.remove('active'));
          this.classList.add('active');

          targetElement.scrollIntoView({
            behavior: 'smooth'
          });

          if (isAlreadyActive) {
            const anchorToClick = targetElement.querySelector('a[href^="/"]');
            if (anchorToClick) {
              setTimeout(() => {
                anchorToClick.click();
              }, 500);
            }
          }
        }
      }
    });

  });


  function setActiveSection() {
    let foundActive = false;


    for (let i = sections.length - 1; i >= 0; i--) {
      const section = sections[i];
      const rect = section.element.getBoundingClientRect();


      if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
        if (!section.link.classList.contains('active')) {

          navLinks.forEach(link => link.classList.remove('active'));

          section.link.classList.add('active');
          foundActive = true;
        }
        break;
      }
    }


    if (!foundActive && window.scrollY === 0 && sections.length > 0) {
      navLinks.forEach(link => link.classList.remove('active'));
      sections[0].link.classList.add('active');
    }
  }


  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }


  window.addEventListener('scroll', debounce(setActiveSection, 50));

  setActiveSection();
});

// Start - Display metafield based text under product media - Gallery info label

document.addEventListener("DOMContentLoaded", function () {
  const modelInfoElement = document.querySelector('.product-variant-picker__model-info .clothing-size');
  const imageWrapper = document.querySelector('.MobileGallery');

  if (modelInfoElement && imageWrapper) {
    const modelInfoText = modelInfoElement.textContent.trim();
    const highlightDiv = document.createElement('div');
    highlightDiv.className = 'highlight-model-size';
    highlightDiv.textContent = modelInfoText;

    imageWrapper.appendChild(highlightDiv);
  }
});


// End - Display metafield based text under product media - Gallery info label
